import { FlightSaleType } from './form-type';

export function totalFlightRescheduleCalculation(
  flightSales: FlightSaleType[],
) {
  return flightSales.reduce((prev, curr) => {
    //guest
    const guest = curr.flightSaleGuests
      .filter((guest) => guest.isSelected)
      .reduce((prevGuest, guest) => {
        return prevGuest + guest.price;
      }, 0);
    //addons
    const addons = curr.flightSaleAddOns
      .filter((addons) => addons.isSelected)
      .reduce((prevAddOns, addons) => prevAddOns + addons.price, 0);
    return prev + guest + addons;
  }, 0);
}
